
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Search, MapPin, Euro } from "lucide-react";

interface JongerenreizenFiltersProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  countryFilter: string;
  setCountryFilter: (country: string) => void;
  priceFilter: string;
  setPriceFilter: (price: string) => void;
  countries: string[];
}

export const JongerenreizenFilters = ({
  searchTerm,
  setSearchTerm,
  countryFilter,
  setCountryFilter,
  priceFilter,
  setPriceFilter,
  countries
}: JongerenreizenFiltersProps) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 space-y-4">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">Filters</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="space-y-2">
          <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
            <Search className="h-4 w-4" />
            Zoeken
          </label>
          <Input
            type="text"
            placeholder="Zoek in bestemmingen..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full"
          />
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
            <MapPin className="h-4 w-4" />
            Land
          </label>
          <Select value={countryFilter} onValueChange={setCountryFilter}>
            <SelectTrigger>
              <SelectValue placeholder="Alle landen" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Alle landen</SelectItem>
              {countries.map(country => (
                <SelectItem key={country} value={country}>{country}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
            <Euro className="h-4 w-4" />
            Prijsklasse
          </label>
          <Select value={priceFilter} onValueChange={setPriceFilter}>
            <SelectTrigger>
              <SelectValue placeholder="Alle prijzen" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Alle prijzen</SelectItem>
              <SelectItem value="budget">Budget (tot €500)</SelectItem>
              <SelectItem value="mid">Middel (€500-€1000)</SelectItem>
              <SelectItem value="high">Hoog (€1000+)</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
};
